import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { FormArray } from '@angular/forms';
import { PDFDocumentProxy } from 'ng2-pdf-viewer';
import { Subscription } from 'rxjs';
import { skip } from 'rxjs/operators';
import { TipoFirmante } from '../../../envios/models/tipo-firmante';
import { ContenidoDocVisible } from '../../models/contenido-doc-visible';
import { CasillaDibujo, FirmaDibujo, PosicionFormularioConFirmante } from '../../models/firmante-nif';
import { DatosConfiguracionDocumentosService } from '../../services/datos-configuracion-documentos.service';
import { FormularioDocumentoService } from '../../services/formulario-documento.service';
import { TipoDocumento } from '../../models/tipo-documento';
import { DocDragComponent } from '../doc-drag/doc-drag.component';
import { CamposDibujoComponent } from '../configuracion-campos-editables/campos-dibujo/campos-dibujo.component';
import { CasillasDibujoComponent } from '../configuracion-formularios/casillas-dibujo/casillas-dibujo.component';
import { ExtraInfoCasillasCamposComponent } from '../extra-info-casillas-campos/extra-info-casillas-campos.component';
import { DatosDocumentosService } from '../../services/datos-documentos.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationMessageComponent } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/components/confirmation-message/confirmation-message.component';
import { TipoMensajeConfirmacion } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/models/confirmation-message-data';
import { firmanteOverlayStyle, casillaOverlayStyle, firmaOverlayStyle } from '../configuracion-panel-firmantes-unificado/firmante-color.tokens';

@Component({
  selector: 'app-configuracion-documento-upload',
  templateUrl: './configuracion-documento-upload.component.html',
  styleUrls: ['./configuracion-documento-upload.component.css']
})
export class ConfiguracionDocumentoUploadComponent implements OnInit,OnDestroy {

  @Output() fileListEmitter: EventEmitter<FileList> = new EventEmitter<FileList>();
  @Output() oldDocEmitter: EventEmitter<TipoDocumento> = new EventEmitter<TipoDocumento>();
  @Output() ficheroCargado:EventEmitter<string> = new EventEmitter();
  @Output() pdfLoadComplete: EventEmitter<{ totalPages: number; totalPagesAntesCambioDoc: number }> = new EventEmitter();
  @Input() src:string = '';
  @Input() pdfCargado:boolean = false;
  @Input() indexPaso: number = 1;
  @Input() idDocumentoEditar: number;
  @Input() idPdf: string;
  /** Activa el modo Envio simple: oculta controles de UI no aplicables (p.ej. llave inglesa). */
  @Input() modoEnvioSimple = false;
  idDocTemporal: string = '';
  page: number = 1;
  totalPages: number;
  @ViewChild('inputPagina') inputPagina: ElementRef;
  @ViewChild('pdfDoc') pdfDoc: ElementRef;
  pdfPosition: { left: number, top: number, height: number, width: number }
  listener: any;
  pdfScrollUnlisten: (() => void) | null = null;
  resizeListener: any;
  viewerContainer: any;
  drags: number = 0;
  palabrasArrayPagina: ContenidoDocVisible[] = [];
  medidaReal: {altura: number, anchura: number};
  medidaPdf: {altura:number,anchura:number}
  firmasArrayPagina: FirmaDibujo[] = [];
  @Input() firmanteSeleccionado: TipoFirmante;
  firmasArrayFirmante: FirmaDibujo[];
  casillasArrayFirmante: CasillaDibujo[];
  casillasArrayPagina: CasillaDibujo[];
  idCasilla: number = 0;
  camposArrayFirmante: CasillaDibujo[];
  camposArrayPagina: CasillaDibujo[];
  cargando: boolean = true;
  scrolltop: number = 0;
  PalbraSuscription: Subscription;
  FirmasSuscription: Subscription;
  VaciarArrayFirmasSuscription:Subscription;
  GetNuevaCasillaSuscription:Subscription
  GetNuevoCampoSuscription:Subscription;
  VaciarArrayFormulariosSuscription:Subscription;
  VaciarArrayCamposEditablesSuscription:Subscription;
  totalPagesAntesCambioDoc:number;
  formularioHighlight: { firmanteCodigo: string; idNombreFormulario: number } | null = null;
  formularioHighlightSubscription: Subscription;
  documentos: TipoDocumento[] = [];
  suscripcionBorrarCasilla: Subscription;

  /** Casilla being edited in extra-info panel (from casillas-dibujo). Panel is rendered at parent so it appears above all casillas. */
  editing145Data: (CasillaDibujo & { tipoInfo?: string }) | null = null;
  editing145AnchorRect: DOMRect | null = null;
  @ViewChild('docDragComponent') docDragComponent: DocDragComponent;
  @ViewChild('camposDibujoComponent') camposDibujoComponent: CamposDibujoComponent;
  @ViewChild('casillasDibujoComponent') casillasDibujoComponent: CasillasDibujoComponent;
  @ViewChild('extraInfoCasillasCamposComponent') extraInfoCasillasCamposComponent: ExtraInfoCasillasCamposComponent;

  constructor(private datosConfiguracionDocumentosService: DatosConfiguracionDocumentosService,
              private render:Renderer2,
              private formularioDocumentoService: FormularioDocumentoService,
              private datosDocumentosService: DatosDocumentosService,
              private dialog: MatDialog,
              private cdr: ChangeDetectorRef) {
                this.listener = () => {};
                this.getNuevaPalabra();
                this.getNuevaFirma();
                this.vaciarArrayFirmas();
                this.getNuevaCasilla();
                this.getNuevoCampo();
                this.vaciarArrayFormularios();
                this.vaciarArrayCamposEditables();
                this.borrarCasillaSubscription();
              }

  //guardamos lo que haya seleccionado en un firmante antes de cambiar a otro.
  ngOnChanges(changes: SimpleChanges){
    if (
      this.modoEnvioSimple &&
      changes.src &&
      !changes.src.firstChange &&
      changes.src.currentValue !== changes.src.previousValue
    ) {
      this.resetearPagina();
    }
    if(changes.firmanteSeleccionado?.previousValue){
      //los llamamos a los tres para que actualice en pantalla los dibujos si se ha borrado algún firmante adicional y se han renombrado los posteriores.
      this.refreshFirmasOverlays();
      this.refreshCasillasOverlays();
      this.refreshCamposOverlays();
    }
    if (changes.indexPaso && !changes.indexPaso.firstChange) {
      this.refreshFirmasOverlays();
      this.refreshCasillasOverlays();
      this.refreshCamposOverlays();
    }
    this.mostrarFirmasFirmante();
    this.mostrarCasillasFirmante();
    this.mostrarCamposFirmante();
  }

  ngOnInit(): void {
    this.formularioHighlightSubscription = this.datosConfiguracionDocumentosService.datosFormularioHighlight$.subscribe(
      (highlight) => {
        this.formularioHighlight = highlight;
        this.cdr.markForCheck();
      }
    );
    // this.formularioDocumentoService.getDocumentosData(); //llamamos a la función para que se carguen los documentos en el servcio del formulario y estos estén listos para hacer la validación del nombre del documento.
    // Listen for window resize events to recalculate PDF position
    this.resizeListener = this.render.listen('window', 'resize', () => {
      if (this.pdfCargado && this.pdfDoc) {
        // Use setTimeout to ensure DOM has updated after resize
        setTimeout(() => {
          this.loadBox();
          // Reconvert all coordinates to match new PDF dimensions
          if (this.medidaPdf) {
            this.refreshPalabrasOverlays();
            this.refreshFirmasOverlays();
            this.refreshCasillasOverlays();
            this.refreshCamposOverlays();
          }
        }, 100);
      }
    });
  }

  ngOnDestroy(): void {
    this.listener();
    this.detachPdfScrollListener();
    if(this.resizeListener) this.resizeListener();
    //this.datosConfiguracionDocumentosService.infoCasilla$.next({});
    if(this.PalbraSuscription) this.PalbraSuscription.unsubscribe();
    if(this.FirmasSuscription) this.FirmasSuscription.unsubscribe();
    if(this.VaciarArrayFirmasSuscription) this.VaciarArrayFirmasSuscription.unsubscribe();
    if(this.GetNuevaCasillaSuscription) this.GetNuevaCasillaSuscription.unsubscribe();
    if(this.GetNuevoCampoSuscription) this.GetNuevoCampoSuscription.unsubscribe();
    if(this.VaciarArrayFormulariosSuscription) this.VaciarArrayFormulariosSuscription.unsubscribe();
    if(this.VaciarArrayCamposEditablesSuscription) this.VaciarArrayCamposEditablesSuscription.unsubscribe();
    if(this.suscripcionBorrarCasilla) this.suscripcionBorrarCasilla.unsubscribe();
    if(this.formularioHighlightSubscription) this.formularioHighlightSubscription.unsubscribe();
  }

  pageRendered(e:any){
    if(e.pageNumber!=this.page) return;
    this.medidaPdf ={
      altura:e.source.height,
      anchura:e.source.width
    }
    this.medidaPdf.anchura=e.source.width;
    this.formularioDocumentoService.setPdfViewport(this.medidaPdf);
    // Recalculate PDF position when page is rendered (handles resize scenarios)
    this.loadBox();
    this.refreshPalabrasOverlays();
    this.refreshFirmasOverlays();
    this.refreshCasillasOverlays();
    this.refreshCamposOverlays();
    this.formularioDocumentoService.capturarDocumentoAEditarSiPendiente();
    this.attachPdfScrollListener();
  }

  getYPosition(e: Event): number {
    return (e.target as Element).scrollTop;
  }

  uploadFiles(data: FileList | any){
    if(!(data instanceof FileList)) data = data.target?.files;
    this.fileListEmitter.emit(data);
    this.pdfCargado = true;
  }

  get accept():string { return 'application/pdf' }

  afterLoadComplete(pdfData: PDFDocumentProxy) {
    this.totalPagesAntesCambioDoc = this.totalPages;
    this.totalPages = pdfData.numPages;
    this.pdfLoadComplete.emit({
      totalPages: this.totalPages,
      totalPagesAntesCambioDoc: this.totalPagesAntesCambioDoc
    });
  }

  completarCargaFormulario(): void {
    this.loadBox();
    this.refreshPalabrasOverlays();
    this.refreshFirmasOverlays();
    this.refreshCasillasOverlays();
    this.refreshCamposOverlays();
    this.formularioDocumentoService.capturarDocumentoAEditarSiPendiente();
    this.ficheroCargado.emit("ok");
  }

  showSpinner(event: {loaded: number, total: number}){
    this.cargando = event.loaded < event.total;
  }

  verCambios(): void {
    this.attachPdfScrollListener();
  }

  private attachPdfScrollListener(): void {
    const element = window.document.getElementsByClassName('ng2-pdf-viewer-container').item(0);
    if (!element) {
      return;
    }
    this.detachPdfScrollListener();
    this.scrolltop = element.scrollTop;
    this.pdfScrollUnlisten = this.render.listen(element, 'scroll', () => {
      this.drags = 0;
      this.scrolltop = element.scrollTop;
      this.cdr.markForCheck();
    });
  }

  private detachPdfScrollListener(): void {
    if (this.pdfScrollUnlisten) {
      this.pdfScrollUnlisten();
      this.pdfScrollUnlisten = null;
    }
  }

  /** Reinicia el contador de paginas al cambiar de documento (modo Envio simple). */
  private resetearPagina(): void {
    this.page = 1;
    this.datosConfiguracionDocumentosService.pagina = this.page;
    if (this.inputPagina) {
      this.inputPagina.nativeElement.value = this.page;
    }
  }

  cambioPagina(numero:number){
    this.page += numero;
    this.datosConfiguracionDocumentosService.pagina = this.page;
    this.inputPagina.nativeElement.value = this.page
    this.mostrarPalabraPagina();
    this.mostrarFirmasPagina();
    this.mostrarCasillasPagina('cambioPagina');
    this.mostrarCamposPagina();
  }

  irPagina(numero:any){
    this.page = parseInt(numero);
    this.mostrarPalabraPagina();
    this.mostrarFirmasPagina();
    this.mostrarCasillasPagina('irPagina');
    this.mostrarCamposPagina();
  }

  //buscamos las dimensiones del pdf
  loadBox(){
    const {left, top, height, width} = this.pdfDoc.nativeElement.getBoundingClientRect();
    //lo que se ve en pantalla
    this.pdfPosition = {left, top, height, width};

    this.datosConfiguracionDocumentosService.docPosition = this.pdfPosition;
    this.getDimensionesRealesDoc();
  }

  getDimensionesRealesDoc(){
    this.medidaReal = {
      anchura: this.pdfPosition.width,
      altura: (this.pdfPosition.width*1123)/794,
      // altura: (this.pdfPosition.width*3508)/2480,
    }
  }

  //-------Métodos para dibujar los tipos de contenido (palabras)--------//

  datosSubscription: Subscription;

  getNuevasCoord(e: any): void {
    if (this.medidaPdf) {
      this.formularioDocumentoService.setPdfViewport(this.medidaPdf);
      this.formularioDocumentoService.updatePalabraPosition(
        e.id,
        {
          x: e.xAfterDrag,
          y: e.yAfterDrag,
          width: e.width,
          height: e.height,
        },
        {
          page: this.page,
          tipo: e.tipo,
          identificador: e.identificador,
          nombre: e.nombre,
        }
      );
    }
    this.refreshPalabrasOverlays();
  }

  getNuevaPalabra(): void {
    this.PalbraSuscription = this.datosConfiguracionDocumentosService.datosPalabra$.subscribe((value: any) => {
      try {
        const isEmpty = Object.keys(value).length === 0;
        if (isEmpty) {
          if (this.formularioDocumentoService.cancelarCopiaDoc) {
            this.formularioDocumentoService.clearAllPalabras();
          }
          this.refreshPalabrasOverlays();
          return;
        }
        if (value.hasOwnProperty('posicionHeight')) {
          this.refreshPalabrasOverlays();
          return;
        }

        if (!value.tipo) {
          return;
        }

        if (this.medidaPdf) {
          const element = window.document.getElementsByClassName('ng2-pdf-viewer-container').item(0);
          const scrolltop = element?.scrollTop ?? 0;
          this.formularioDocumentoService.setPdfViewport(this.medidaPdf);
          this.formularioDocumentoService.addPalabraFromPixel(
            {
              x: value.x,
              y: value.y + scrolltop,
              width: value.width,
              height: value.height,
            },
            {
              page: this.page,
              tipo: value.tipo,
              identificador: '',
              nombre: '',
            }
          );
          this.formularioDocumentoService.cancelarCopiaDoc = false;
        }
        this.refreshPalabrasOverlays();
      } catch (error) {
        console.error(error);
      }
    });
  }

  borrarPalabraArray(eventID: number): void {
    this.formularioDocumentoService.removePalabraById(eventID);
    this.onCerrarExtraInfo();
    this.refreshPalabrasOverlays();
  }

  mostrarPalabraPagina(): void {
    if (!this.medidaPdf) {
      this.palabrasArrayPagina = [];
      return;
    }
    this.formularioDocumentoService.setPdfViewport(this.medidaPdf);
    this.palabrasArrayPagina = this.formularioDocumentoService.getOverlaysForPage('palabra', this.page);
  }

  refreshPalabrasOverlays(): void {
    if (!this.medidaPdf) {
      return;
    }
    this.formularioDocumentoService.setPdfViewport(this.medidaPdf);
    this.mostrarPalabraPagina();
  }

//-------Métodos para dibujar las firmas--------

  firmante: TipoFirmante;

  getNuevasCoordFirma(e: any): void {
    if (this.medidaPdf) {
      this.formularioDocumentoService.setPdfViewport(this.medidaPdf);
      const updated = this.formularioDocumentoService.updateFirmaPosition(
        e.id,
        e.firmante.codigo,
        {
          x: e.xAfterDrag,
          y: e.yAfterDrag,
          width: e.width,
          height: e.height,
        },
        { page: this.page }
      );
      if (!updated) {
        // Fallo de locate: refrescar desde form (el overlay ya reseteo transform).
        this.refreshFirmasOverlays();
        return;
      }
    }
    this.refreshFirmasOverlays();
  }

  borrarFirmaArray(eventID: number): void {
    this.formularioDocumentoService.removeFirmaById(eventID);
    this.refreshFirmasOverlays();
  }

  getNuevaFirma(): void {
    this.FirmasSuscription = this.datosConfiguracionDocumentosService.datosFirma$.subscribe((value: any) => {
      try {
        const isEmpty = Object.keys(value).length === 0;
        if (isEmpty) {
          this.refreshFirmasOverlays();
          return;
        }
        if (value.hasOwnProperty('posicionHeight')) {
          this.refreshFirmasOverlays();
          return;
        }

        const firmante = value.firmante;
        if (!firmante?.codigo) {
          return;
        }

        if (this.medidaPdf) {
          const element = window.document.getElementsByClassName('ng2-pdf-viewer-container').item(0);
          const scrolltop = element?.scrollTop ?? 0;
          this.formularioDocumentoService.setPdfViewport(this.medidaPdf);
          this.formularioDocumentoService.addFirmaFromPixel(
            {
              x: value.x,
              y: value.y + scrolltop,
              width: value.width,
              height: value.height,
            },
            { firmante, page: this.page }
          );
          this.formularioDocumentoService.cancelarCopiaDoc = false;
          this.datosConfiguracionDocumentosService.infoFirma$.next({});
        }
        this.refreshFirmasOverlays();
      } catch (error) {
        console.error(error);
      }
    });
  }

  vaciarArrayFirmas(): void {
    // skip(1): el BehaviorSubject reemite su valor inicial ({}) al suscribirse. Como {} se
    // interpreta como "vaciar todo", esa reemision borraria las firmas recien hidratadas en
    // Envio simple (donde el preview se crea despues de hidratar). Solo reaccionamos a
    // vaciados reales emitidos despues de la suscripcion.
    this.VaciarArrayFirmasSuscription =
      this.datosConfiguracionDocumentosService.datosArrayFirmasVacio$.pipe(skip(1)).subscribe((value: any) => {
        try {
          const isEmpty = Object.keys(value).length === 0;
          if (isEmpty) {
            this.formularioDocumentoService.clearAllPosicionFirmas();
          } else {
            this.formularioDocumentoService.removeFirmasForFirmante(value.codigo);
          }
          this.refreshFirmasOverlays();
        } catch (error) {
          console.log(error);
        }
      });
  }

  mostrarFirmasPagina(): void {
    if (!this.medidaPdf) {
      this.firmasArrayPagina = [];
      this.firmasArrayFirmante = [];
      return;
    }
    this.formularioDocumentoService.setPdfViewport(this.medidaPdf);
    this.firmasArrayPagina = this.formularioDocumentoService.getOverlaysForPage('firma', this.page);
    this.mostrarFirmasFirmante();
  }

  mostrarFirmasFirmante(): void {
    if (!this.medidaPdf) {
      this.firmasArrayFirmante = [];
      return;
    }
    this.formularioDocumentoService.setPdfViewport(this.medidaPdf);
    if (this.mostrarTodosLosDibujosEnPdf()) {
      this.firmasArrayFirmante = this.formularioDocumentoService.getOverlaysForPage('firma', this.page);
      return;
    }
    if (this.firmanteSeleccionado) {
      this.firmasArrayFirmante = this.formularioDocumentoService.getOverlaysForPage(
        'firma',
        this.page,
        this.firmanteSeleccionado
      );
    } else {
      this.firmasArrayFirmante = [];
    }
  }

  refreshFirmasOverlays(): void {
    if (!this.medidaPdf) {
      return;
    }
    this.formularioDocumentoService.setPdfViewport(this.medidaPdf);
    this.mostrarFirmasPagina();
  }

  get firmantesNif(): FormArray {
    return this.formularioDocumentoService.formularioDocumento.controls['firmantesNif'] as FormArray;
  }

  //-------Métodos para dibujar las casillas de los formularios para cada firmante--------//

  //cargamos la casilla que se está moviendo en este momento a través de un observable, añadimos la página en la que está, buscamos el id más grande que ya exista en el array y le añadimos uno para la nueva casilla y push al array

  entramos: number=0

  datosSubcription: Subscription;

  getNuevaCasilla(){
   this.GetNuevaCasillaSuscription = this.datosConfiguracionDocumentosService.datosCasilla$.subscribe((value:any) => {
    try{
          const isEmpty = Object.keys(value).length
          if(isEmpty == 0){
            this.refreshCasillasOverlays();
            return;
          }
          if(value.hasOwnProperty('posicionHeight')){
            this.refreshCasillasOverlays();
            return;
          }
          if(value.hasOwnProperty('procesado')){
            return;
          }

          let element =  window.document.getElementsByClassName("ng2-pdf-viewer-container").item(0);
            let scrolltop = element?.scrollTop ?? 0;
            let firmante = value.firmante;
            if(firmante?.hasOwnProperty('tipoFirmante')){
              this.firmante = firmante.tipoFirmante;
              firmante = firmante.tipoFirmante;
            }else{
              this.firmante = firmante;
            }
            if (!firmante?.codigo) {
              return;
            }

            if (this.medidaPdf) {
              this.formularioDocumentoService.setPdfViewport(this.medidaPdf);
              this.formularioDocumentoService.addCasillaFromPixel(
                {
                  x: value.x,
                  y: value.y + scrolltop,
                  width: value.width,
                  height: value.height,
                },
                {
                  firmante,
                  page: this.page,
                  nombre: value.nombre,
                  idNombreFormulario: value.idNombreFormulario,
                  valorOpcionSeleccionada: '',
                  obligatorio: value.obligatorio ?? false,
                }
              );
            }
            this.refreshCasillasOverlays();
        }catch(error){
          console.error(error)
        }
    });
  }

  convertirGuardarCasillaSingle(value:any){
    value.posicionTop = (value.y-50)/this.medidaPdf.altura;
    value.posicionLeft = value.x/this.medidaPdf.anchura;
    value.posicionRight = (value.x+value.width)/this.medidaPdf.anchura;
    value.posicionHeight = value.height/this.medidaPdf.altura;
    value.posicionWidth = value.width/this.medidaPdf.anchura;
    value.procesado = true
  }

  mostrarCasillasFirmante(){
    if (!this.medidaPdf) {
      this.casillasArrayFirmante = [];
      return;
    }
    this.formularioDocumentoService.setPdfViewport(this.medidaPdf);
    if (this.mostrarTodosLosDibujosEnPdf()) {
      this.casillasArrayFirmante = this.formularioDocumentoService.getOverlaysForPage('casilla', this.page);
      return;
    }
    if (this.firmanteSeleccionado) {
      this.casillasArrayFirmante = this.formularioDocumentoService.getOverlaysForPage(
        'casilla',
        this.page,
        this.firmanteSeleccionado
      );
    } else {
      this.casillasArrayFirmante = [];
    }
  }

  mostrarCasillasPagina(_origen?: string){
    if (!this.medidaPdf) {
      this.casillasArrayPagina = [];
      this.casillasArrayFirmante = [];
      return;
    }
    this.formularioDocumentoService.setPdfViewport(this.medidaPdf);
    this.casillasArrayPagina = this.formularioDocumentoService.getOverlaysForPage('casilla', this.page);
    if (this.casillasArrayPagina.length === 0) {
      this.casillasArrayFirmante = [];
    } else {
      this.mostrarCasillasFirmante();
    }
  }

  //recogemos la nueva información y actualizamos la casilla en el array a través del id
  getNuevasCoordCasillas(e:any){
    if (this.medidaPdf) {
      this.formularioDocumentoService.setPdfViewport(this.medidaPdf);
      this.formularioDocumentoService.updateCasillaPosition(
        e.id,
        e.firmante.codigo,
        {
          x: e.xAfterDrag,
          y: e.yAfterDrag,
          width: e.width,
          height: e.height,
        },
        {
          page: this.page,
          nombre: e.nombre,
          orden: e.orden,
          valorOpcionSeleccionada: e.valorOpcionSeleccionada,
          obligatorio: e.obligatorio,
          idNombreFormulario: e.idNombreFormulario,
        }
      );
    }
    this.refreshCasillasOverlays();
  }

  borrarCasillaArray(eventID: number): void {
    if (this.formularioDocumentoService.esUltimaCasillaColocadaDelFormulario(eventID)) {
      const meta = this.formularioDocumentoService.getGrupoMetaForCasillaId(eventID);
      if (!meta?.firmanteCodigo) {
        return;
      }
      const nombreDisplay = (meta.nombre ?? '').trim() || 'este formulario';
      const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
        data: {
          tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
          icono: 'icon-delete',
          titulo: '¿Eliminar el formulario?',
          mensaje: `Al borrar la última casilla del formulario "${nombreDisplay}", se eliminará el formulario completo. ¿Desea continuar?`,
          textoConfirmacion: 'Borrar formulario',
          iconoConfirmacion: 'icon-delete',
          textoCancelar: 'Cancelar',
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result !== 'OK') {
          return;
        }
        const idNombre = this.formularioDocumentoService.resolveIdNombreFormularioForDelete(
          eventID,
          meta.idNombreFormulario,
          meta.firmanteCodigo,
          meta.nombre
        );
        this.formularioDocumentoService.deleteFormularioGrupo(
          meta.firmanteCodigo,
          idNombre,
          meta.nombre
        );
        this.onCerrarExtraInfo();
        this.refreshCasillasOverlays();
      });
      return;
    }
    this.formularioDocumentoService.removeCasillaById(eventID);
    this.onCerrarExtraInfo();
    this.refreshCasillasOverlays();
  }

  refreshCasillasOverlays(): void {
    if (!this.medidaPdf) {
      return;
    }
    this.formularioDocumentoService.setPdfViewport(this.medidaPdf);
    this.mostrarCasillasPagina();
  }

  vaciarArrayFormularios(){
    this.VaciarArrayFormulariosSuscription = this.datosConfiguracionDocumentosService.datosArrayFormulariosVacio$.subscribe(() => {
      try{
        this.refreshCasillasOverlays();
      }catch(error){
        console.log(error);
      }
    })
  }

  borrarCasillaSubscription(): void {
    this.suscripcionBorrarCasilla = this.datosConfiguracionDocumentosService.datosCasillaBorrada$.subscribe((value:number) => {
      // This stream is used when deleting an entire formulario from the list.
      // Rebuild from form state to avoid per-casilla side effects (seed row creation,
      // unintended reorder, or cross-form deletions).
      this.refreshCasillasOverlays();
      this.onCerrarExtraInfo();
    });
  }

  onEditarCasilla(event: { casilla: CasillaDibujo; anchorRect: DOMRect }): void {
    this.editing145Data = { ...event.casilla, tipoInfo: 'casillas' };
    this.editing145AnchorRect = event.anchorRect;
  }

  onEditarCampo(event: { campo: CasillaDibujo; anchorRect: DOMRect }): void {
    this.editing145Data = { ...event.campo, tipoInfo: 'campos' };
    this.editing145AnchorRect = event.anchorRect;
  }

  onEditarPalabra(event: { palabra: CasillaDibujo; anchorRect: DOMRect }): void {
    this.editing145Data = { ...event.palabra, tipoInfo: 'palabras' };
    this.editing145AnchorRect = event.anchorRect;
  }

  onCerrarExtraInfo(): void {
    this.editing145Data = null;
    this.editing145AnchorRect = null;
  }

  onInfoExtraEmitter(event: { tipo: string; data: any }): void {
    switch (event.tipo) {
      case 'casillas':
        this.formularioDocumentoService.updateCasillaExtraInfo(event.data.id, {
          orden: event.data.ordenOpcion,
          valorOpcionSeleccionada: event.data.valorOpcionSeleccionada,
          obligatorio: event.data.obligatorio,
        });
        this.refreshCasillasOverlays();
        break;
      case 'campos':
        this.formularioDocumentoService.updateCampoExtraInfo(event.data.id, {
          identificador: event.data.identificadorCampo,
          nombreCampo: event.data.nombreCampo,
          valorPorDefecto: event.data.valorPorDefecto,
          obligatorio: event.data.obligatorio,
        });
        this.refreshCamposOverlays();
        break;
      case 'palabras':
        this.formularioDocumentoService.updatePalabraExtraInfo(event.data.id, {
          identificador: event.data.identificadorPalabra,
          nombre: event.data.nombrePalabra,
        });
        this.refreshPalabrasOverlays();
        break;
      default:
        break;
    }
  }

  onBorrarInfoExtra(event: { tipo: string; id: number }): void {
    if (event.tipo === 'casillas' && !this.permiteEdicionCasillasEnPaso()) return;
    switch (event.tipo) {
      case 'casillas':
        // Delete by id from the shared arrays (single source of truth).
        // Using a single @ViewChild can point to a different rendered item.
        this.borrarCasillaArray(event.id);
        break;
      case 'campos':
        this.borrarCampoArray(event.id);
        break;
      case 'palabras':
        this.borrarPalabraArray(event.id ?? this.editing145Data?.id);
        break;
    }
  }

  permiteBorradoExtraInfo(): boolean {
    if (this.editing145Data?.tipoInfo === 'casillas') return this.permiteEdicionCasillasEnPaso();
    return true;
  }

  /** Paso 8 unificado: permite mover/borrar casillas en PDF. */
  permiteEdicionCasillasEnPaso(): boolean {
    return this.indexPaso === 8;
  }

  /** Paso 8 unificado: firma, casillas y campos editables en el mismo índice. */
  esPanelFirmantesUnificado(): boolean {
    return this.indexPaso === 8;
  }

  /** Todos los dibujos visibles en el PDF (desde la carga). */
  mostrarTodosLosDibujosEnPdf(): boolean {
    return true;
  }

  overlayStyleFor(codigo: string | undefined): Record<string, string> {
    return this.mostrarTodosLosDibujosEnPdf() ? firmanteOverlayStyle(codigo) : {};
  }

  /** Estilo de la firma: color del firmante mas marcado que casillas/campos. */
  overlayStyleForFirma(codigo: string | undefined): Record<string, string> {
    return this.mostrarTodosLosDibujosEnPdf() ? firmaOverlayStyle(codigo) : {};
  }

  overlayStyleForCasilla(casilla: { firmante?: { codigo?: string }; idNombreFormulario?: number | null }): Record<string, string> {
    return this.mostrarTodosLosDibujosEnPdf()
      ? casillaOverlayStyle(casilla.firmante?.codigo, this.isCasillaHighlighted(casilla))
      : {};
  }

  private isCasillaHighlighted(casilla: { firmante?: { codigo?: string }; idNombreFormulario?: number | null }): boolean {
    if (!this.formularioHighlight) {
      return false;
    }
    return (
      casilla.firmante?.codigo === this.formularioHighlight.firmanteCodigo &&
      casilla.idNombreFormulario === this.formularioHighlight.idNombreFormulario
    );
  }

  //-------Métodos para dibujar los campos de los campos editables para cada firmante--------//

  //cargamos la palabra que se está moviendo en este momento a través de un observable, añadimos la página en la que está, buscamos el id más grande que ya exista en el array y le añadimos uno para la nueva palabra y push al array. Si es la primera palabra iniciamos el id con 0. isEmpty mira si el objeto observado tiene valor o no.
  getNuevoCampo(){
    this.GetNuevoCampoSuscription = this.datosConfiguracionDocumentosService.datosCampo$.subscribe((value:any) => {
      try{
        const isEmpty = Object.keys(value).length === 0;
        if(isEmpty){
          this.refreshCamposOverlays();
          return;
        }
        if(value.hasOwnProperty('posicionHeight')){
          this.refreshCamposOverlays();
          return;
        }

        const firmante = value.firmante;
        if(!firmante?.codigo){
          return;
        }

        if(this.medidaPdf){
          const element = window.document.getElementsByClassName('ng2-pdf-viewer-container').item(0);
          const scrolltop = element?.scrollTop ?? 0;
          this.formularioDocumentoService.setPdfViewport(this.medidaPdf);
          this.formularioDocumentoService.addCampoFromPixel(
            {
              x: value.x,
              y: value.y + scrolltop,
              width: value.width,
              height: value.height,
            },
            {
              firmante,
              page: this.page,
              identificador: value.identificador,
              nombreCampo: value.nombreCampo,
              valorPorDefecto: value.valorPorDefecto,
              obligatorio: value.obligatorio,
            }
          );
          this.formularioDocumentoService.cancelarCopiaDoc = false;
          this.datosConfiguracionDocumentosService.infoCampo$.next({});
        }
        this.refreshCamposOverlays();
      }catch(error){
        console.error(error);
      }
    })
  }

  mostrarCamposPagina(){
    if(!this.medidaPdf){
      this.camposArrayPagina = [];
      this.camposArrayFirmante = [];
      return;
    }
    this.formularioDocumentoService.setPdfViewport(this.medidaPdf);
    this.camposArrayPagina = this.formularioDocumentoService.getOverlaysForPage('campo', this.page);
    this.mostrarCamposFirmante();
  }

  mostrarCamposFirmante(){
    if (!this.medidaPdf) {
      this.camposArrayFirmante = [];
      return;
    }
    this.formularioDocumentoService.setPdfViewport(this.medidaPdf);
    if (this.mostrarTodosLosDibujosEnPdf()) {
      this.camposArrayFirmante = this.formularioDocumentoService.getOverlaysForPage('campo', this.page);
      return;
    }
    if (this.firmanteSeleccionado) {
      this.camposArrayFirmante = this.formularioDocumentoService.getOverlaysForPage(
        'campo',
        this.page,
        this.firmanteSeleccionado
      );
    } else {
      this.camposArrayFirmante = [];
    }
  }

  refreshCamposOverlays(): void {
    if(!this.medidaPdf){
      return;
    }
    this.formularioDocumentoService.setPdfViewport(this.medidaPdf);
    this.mostrarCamposPagina();
  }

  getNuevasCoordCampo(e:any){
    if(this.medidaPdf){
      this.formularioDocumentoService.setPdfViewport(this.medidaPdf);
      this.formularioDocumentoService.updateCampoPosition(
        e.id,
        e.firmante.codigo,
        {
          x: e.xAfterDrag,
          y: e.yAfterDrag,
          width: e.width,
          height: e.height,
        },
        { page: this.page }
      );
    }
    this.refreshCamposOverlays();
  }

  borrarCampoArray(eventId:number){
    this.formularioDocumentoService.removeCampoById(eventId);
    this.onCerrarExtraInfo();
    this.refreshCamposOverlays();
  }

  vaciarArrayCamposEditables(){
    // skip(1): mismo motivo que vaciarArrayFirmas. La reemision inicial ({}) del BehaviorSubject
    // borraria los campos editables recien hidratados en Envio simple.
    this.VaciarArrayCamposEditablesSuscription = this.datosConfiguracionDocumentosService.datosArrayCamposEditablesVacio$.pipe(skip(1)).subscribe((value:any) => {
      try{
        const isEmpty = Object.keys(value).length === 0;
        if(isEmpty){
          this.formularioDocumentoService.clearAllCamposEditables();
        }else{
          this.formularioDocumentoService.removeCamposForFirmante(value.codigo);
        }
        this.refreshCamposOverlays();
      }catch(error){
        console.log(error);
      }
    })
  }
}
